import { create } from 'zustand'

interface SessionState {
  isAdmin: boolean
  userApiKey: string | null
  setAdmin: (isAdmin: boolean) => void
  setUserApiKey: (key: string | null) => void
  hasModelAccess: (model: string) => boolean
}

// Load from localStorage on init
const loadFromStorage = (): { isAdmin: boolean; userApiKey: string | null } => {
  if (typeof window === 'undefined') return { isAdmin: false, userApiKey: null }
  const stored = localStorage.getItem('session-storage')
  if (stored) {
    try {
      const parsed = JSON.parse(stored)
      return {
        isAdmin: parsed.isAdmin ?? false,
        userApiKey: parsed.userApiKey ?? null,
      }
    } catch {
      return { isAdmin: false, userApiKey: null }
    }
  }
  return { isAdmin: false, userApiKey: null }
}

const initialState = loadFromStorage()

export const useSessionStore = create<SessionState>((set, get) => ({
  ...initialState,
  setAdmin: (isAdmin: boolean) => {
    set({ isAdmin })
    if (typeof window !== 'undefined') {
      localStorage.setItem('session-storage', JSON.stringify({ ...get(), isAdmin }))
    }
  },
  setUserApiKey: (key: string | null) => {
    set({ userApiKey: key })
    if (typeof window !== 'undefined') {
      localStorage.setItem('session-storage', JSON.stringify({ ...get(), userApiKey: key }))
    }
  },
  hasModelAccess: (model: string) => {
    const state = get()
    // Non-admin users only have access to gpt-5-nano unless they provide their own API key
    if (state.isAdmin) return true
    if (state.userApiKey) return true
    return model === 'gpt-5-nano'
  },
}))

